<template>
  <div>
    <div class="mx-auto">{{ message }}</div>
    <div @click="$emit('onDeleteNotification', id)" class="flex-shrink-0 ml-5 cursor-pointer pt-1">
      <aw-icon icon="close" class="w-6 h-6 transform -translate-y-0.5" />
    </div>
  </div>
</template>

<script>
export default {
  emits: [],
  props: {
    id: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
